import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import * as yup from 'yup'

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    recipients: yup
      .array()
      .of(yup.string().nullable())
      .test(
        'not-empty',
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('SentEmailLog:sentEmailLog.filed.recipients'),
        }),
        (value) => value !== undefined && value.length > 0,
      )
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('SentEmailLog:sentEmailLog.filed.recipients'),
        }),
      ),
    messageDate: yup
      .array()
      .of(yup.string())
      .min(
        1,
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('SentEmailLog:sentEmailLog.filed.messageDate'),
        }),
      )
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('SentEmailLog:sentEmailLog.filed.messageDate'),
        }),
      ),
  })
  return validationSchema
}

export { generateValidationSchema }
